const TABLE_IMAGE_API_URL = 'https://api-zepika.panorama.works/public/api';
const TABLE_IMAGE_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/heic'
]);

function validateTableImageFile(file) {
  if (!file) {
    throw new Error('Selecciona una imagen para subir.');
  }
  if (file.size > 20 * 1024 * 1024) {
    throw new Error('La imagen no debe pesar más de 20 MB.');
  }
  if (!TABLE_IMAGE_TYPES.has(file.type)) {
    throw new Error('Formato no compatible. Usa JPEG, PNG, WebP, GIF o HEIC.');
  }
}

async function updateCollImage(collectionId, file) {
  validateTableImageFile(file);

  const targetResponse = await fetch(`${TABLE_IMAGE_API_URL}/v2.1/collections/table-image/upload-target`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      collection_id: String(collectionId),
      filename: file.name,
      mime_type: file.type
    })
  });
  const targetResult = await targetResponse.json();
  if (!targetResponse.ok || !targetResult.status) {
    throw new Error(targetResult.error || targetResult.message || 'No se pudo iniciar la carga de la imagen.');
  }

  const { upload, completion_token: completionToken } = targetResult.data || {};
  if (
    !upload?.url ||
    !upload.method ||
    !Array.isArray(upload.parameters) ||
    !completionToken
  ) {
    throw new Error('La API devolvió un destino de carga incompleto.');
  }

  const uploadHeaders = Object.fromEntries(
    upload.parameters.map(({ name, value }) => [name, value])
  );
  const shopifyResponse = await fetch(upload.url, {
    method: upload.method,
    headers: uploadHeaders,
    body: file
  });
  if (!shopifyResponse.ok) {
    throw new Error(`Falló la carga de la imagen (${shopifyResponse.status}).`);
  }

  const completionResponse = await fetch(`${TABLE_IMAGE_API_URL}/v2.1/collections/table-image/complete`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ completion_token: completionToken })
  });
  const completionResult = await completionResponse.json();
  if (!completionResponse.ok || !completionResult.status) {
    throw new Error(completionResult.error || completionResult.message || 'No se pudo actualizar la imagen de la mesa.');
  }
  return completionResult;
}

let selectedTableImageFile = null;
let tableImagePreviewUrl = null;
const createTableImageInput = document.getElementById('CM_imagen');

function getSelectedTableImageFile() {
  return selectedTableImageFile;
}

if (createTableImageInput) {
  createTableImageInput.addEventListener('change', function () {
    selectedTableImageFile = this.files[0] || null;
    if (!selectedTableImageFile) {
      return;
    }
    try {
      validateTableImageFile(selectedTableImageFile);
      if (tableImagePreviewUrl) {
        URL.revokeObjectURL(tableImagePreviewUrl);
      }
      tableImagePreviewUrl = URL.createObjectURL(selectedTableImageFile);
      document.getElementById('mainPreview').src = tableImagePreviewUrl;
      $('#CM_error_list').empty();
      $('#CM_error').hide();
    } catch (error) {
      this.value = '';
      selectedTableImageFile = null;
      $('#CM_error_list').text(error.message);
      $('#CM_error').show();
    }
  });
}

let changeTableImageFile = null;
let changeTableImagePreviewUrl = null;
const changeTableImageInput = document.getElementById('mcf_archivo');
let changefotoColId;

if (changeTableImageInput) {
  changeTableImageInput.addEventListener('change', function () {
    changeTableImageFile = this.files[0] || null;
    if (!changeTableImageFile) {
      return;
    }
    try {
      validateTableImageFile(changeTableImageFile);
      if (changeTableImagePreviewUrl) {
        URL.revokeObjectURL(changeTableImagePreviewUrl);
      }
      changeTableImagePreviewUrl = URL.createObjectURL(changeTableImageFile);
      document.getElementById('mcf_image').src = changeTableImagePreviewUrl;
      $('#mcf_fail').slideUp();
    } catch (error) {
      this.value = '';
      changeTableImageFile = null;
      $('#mcf_fail div').text(error.message);
      $('#mcf_fail').slideDown();
    }
  });
}

function showChangeImageModal(colId) {
  changefotoColId = colId;
  changeTableImageFile = null;
  changeTableImageInput.value = '';
  if (changeTableImagePreviewUrl) {
    URL.revokeObjectURL(changeTableImagePreviewUrl);
    changeTableImagePreviewUrl = null;
  }
  $('#mcf_form').slideDown();
  $('#mcf_done').slideUp();
  $('#mcf_fail').slideUp();
  $('.modal-fix.foto').css({
    'display': 'flex',
    'opacity': '1'
  });
  $('.modal.foto').css('opacity', '1');
  $('#mcf_image').attr('src', $('#image-' + colId).attr('src'));
}

async function changeEventImage() {
  generalLoader.on();
  $('.loader-msg').text('Cambiando imagen');
  $('#mcf_fail').slideUp();
  try {
    await updateCollImage(changefotoColId, changeTableImageFile);
    $('#image-' + changefotoColId).attr('src', changeTableImagePreviewUrl);
    $('#mcf_form').slideUp();
    $('#mcf_done').slideDown();
  } catch (error) {
    console.error('Error al cambiar la imagen de la mesa:', error);
    $('#mcf_fail div').text(error.message);
    $('#mcf_done').slideUp();
    $('#mcf_fail').slideDown();
  } finally {
    generalLoader.off();
  }
}
